import { useMemo } from 'react';
import { toInspectionTemplateItemModel } from 'components/dataProviders/withRequiredInspectionTemplate/model';
import { InspectionTemplateItemModel } from 'components/dataProviders/withRequiredInspectionTemplate/types';
import { useProjectOrganizationId } from 'store/project';
import { useProcessesObject } from 'store/process';
import { useInspectionStore } from '../../../store';
import { useInspectionTemplates } from 'store/inspection/hooks/useInspectionTemplates';
import {
  filterTemplatesByEntityState,
  sortTemplatesByModifiedAtDesc,
} from '../model';

export interface UseInspectionTemplateListItemsResult {
  items: InspectionTemplateItemModel[];
  loading: boolean;
}

export function useInspectionTemplateListItems(): UseInspectionTemplateListItemsResult {
  const { inspectionTemplates, loading } = useInspectionTemplates();
  const inspectionTemplatesListState =
    useInspectionStore.use.inspectionTemplatesListState();
  const processes = useProcessesObject();
  const organizationId = useProjectOrganizationId();

  const items = useMemo(() => {
    const filtered = filterTemplatesByEntityState(
      inspectionTemplates.items,
      inspectionTemplatesListState
    );
    const sorted = sortTemplatesByModifiedAtDesc(filtered);

    return sorted.map((template) =>
      toInspectionTemplateItemModel(processes, template, organizationId)
    );
  }, [
    inspectionTemplates.items,
    inspectionTemplatesListState,
    processes,
    organizationId,
  ]);

  return {
    items,
    loading,
  };
}
